<div class="container-full" style="margin-top:10px;">
    <app-header-title-lot-data
    [title]="'Parking Agreement Report'"
    [lotNumber]="_appGeneralState.currentLotNumber"
    [lotName]="_appGeneralState.currentLotName"
></app-header-title-lot-data>
    
    <mat-card style="margin-top:30px;margin-left:10px;margin-right:0px;width:99%;height:90%;min-height: 600px;">
        <mat-card-header>
        
        </mat-card-header>    
        <mat-card-content>
                <form 
                (ngSubmit)="onFindParkingAgreeements()" 
                novalidate
                [formGroup]="agreementSearchForm" 
                style="margin-top:20px;">
            <div class="row" style="width:100%;">
                <!-- <div class="col-4">
                   
                    Current Lot: {{_appGeneralState.currentLotNumber}}-{{_appGeneralState.currentLotName}}
                </div> -->
                <div class="col-6">
                    <mat-form-field appearance="fill" style="width:100%;color:gray">
                        <mat-label>Agreement Status:</mat-label>
                        <mat-select formControlName="agreementStatus">
                          <mat-option value="ALL">All</mat-option>
                          <mat-option value="6">Agreement Signed</mat-option>
                          <mat-option value="0">Notification Sent/Pending Signature</mat-option>
                          <mat-option value="1">Exempt from Agreement</mat-option>
                          <mat-option value="2">Removed from Exempt & Invite Sent</mat-option>
                          <mat-option value="3">Expired Invitation</mat-option>
                          <mat-option value="4">Parker Termed-Invite Cancelled</mat-option>
                          <mat-option value="5">Parker Viewed Agreement</mat-option>
                          <mat-option value="7">Email Resent/Pending</mat-option>
                          <mat-option value="8">Notification Failed</mat-option>
                          <mat-option value="9">Removed from Exempt - No Invite Sent</mat-option>
                        </mat-select>
                      </mat-form-field>          
                </div>
                <div class="col-6">
                    <mat-form-field   appearance="fill" style="width:100%;color:gray">
                        <mat-label>Date Updated Date Range</mat-label>
                        <mat-date-range-input [rangePicker]="picker">
                          <input matStartDate placeholder="Start date" formControlName="startDate">
                          <input matEndDate placeholder="End date" formControlName="endDate">
                        </mat-date-range-input>
                        <mat-hint>MM/DD/YYYY – MM/DD/YYYY</mat-hint>
                        <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                        <mat-date-range-picker #picker></mat-date-range-picker>
                      </mat-form-field>
                </div>
            </div>
            <div class="row" style="width:100%;margin-top:2px;">
                <div class="col-12">
                    <button type="submit" class="btn btn-primary mt-3 ace-blue" style="margin-left:20px;" [disabled]="!agreementSearchForm.valid">Search</button>
                    <button type="button" class="btn btn-primary mt-3 ace-blue" style="margin-left:20px;" (click)="onClearSearchCriteria()">Clear</button>
                </div>    
            </div>
        </form>

        <ng-container *ngIf="this.parkingAgreementReportList.length > 0">
            <div style="margin-top:30px;"></div>
            <div class="ace-heading-text-secondary" style="font-size:21px;margin-left:10px;">
               Parking Agreements Located: {{parkingAgreementReportList.length}}
            </div>
            <igx-grid #gridParkersV2MainGridzzz id="gridParkersV2MainGridzzz" [data]="parkingAgreementReportList" [width]="'99%'" [height]="'2000px;'" [autoGenerate]="false" style=margin-left:10px;margin-top:10px;
paste-handler  [primaryKey]="'parkerId'" [rowEditable]="false" [allowFiltering]="true"  filterMode="excelStyleFilter" displayDensity="compact" 
[emptyGridMessage]="'Parker Profile List Empty'"  paste-handler   >

<igx-column field="lotNumber" header="Lot No." [sortable]="true" width="120px"></igx-column>
<igx-column field="parkerId" header="Parker Id" [sortable]="true" width="200px"></igx-column>
<igx-column field="lastName" header="Last Name" width="150px" required [sortable]="true" ></igx-column>
<igx-column field="firstName" header="First Name" width="150px" required [sortable]="true" ></igx-column>
<igx-column field="companyName" header="Company Name" width="350px" required [sortable]="true" ></igx-column>
<igx-column field="agreementStatusDisplay" header="Status" width="350px" required [sortable]="true" ></igx-column>
<igx-column field="dateLastUpdatedDisplay" header="Date Updated" width="175px" required [sortable]="true" >
    <ng-template igxCell let-value let-cell="cell">
        <div class="cell__inner">
            @if(value !== '0001-01-01T00:00:00'){
                {{ value | date : 'shortDate'}}
            }
               
        </div>
    </ng-template>
</igx-column>
<igx-column field="userNameLastUpdate" header="Last Update User Name" required ></igx-column>


<igx-grid-toolbar>
    <igx-grid-toolbar-actions>
        <igx-grid-toolbar-pinning></igx-grid-toolbar-pinning>
        <igx-grid-toolbar-hiding></igx-grid-toolbar-hiding>
        <igx-grid-toolbar-exporter></igx-grid-toolbar-exporter>
    </igx-grid-toolbar-actions>
</igx-grid-toolbar>

</igx-grid>
        </ng-container>

        </mat-card-content>
        <mat-card-actions style="margin-top:20px;">
            
      </mat-card-actions>
  
    </mat-card>                                                                             

</div>


